import {Injectable} from '@angular/core';
import {CountryState, Store as CountryStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {Country} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {CountryQuery} from './query';

@Injectable({providedIn: 'root'})
export class CountryService extends EntityService<CountryStore, CountryState> {

  countries$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new Country(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('country.entityTitle'),
    fields: [

      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('country.name'),
        inputType: 'text',
        name: 'name',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('country.code'),
        inputType: 'text',
        name: 'code',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('country.vat'),
        inputType: 'number',
        name: 'vat',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: CountryQuery,
    protected store: CountryStore) {
    super(store, Country);
  }

  get resourceName(): string {
    return 'country';
  }

}
